/**
 * Application route table (assembled by domain).
 * meta.public — skip auth guard; meta.title — document title suffix.
 */
import publicRoutes from './routes/public';
import shellRoutes from './routes/shell';
import crmRoutes from './routes/crm';
import tasksRoutes from './routes/tasks';
import workflowsRoutes from './routes/workflows';
import botsRoutes from './routes/bots';
import linkedinRoutes from './routes/linkedin';
import integrationsRoutes from './routes/integrations';
import aiRoutes from './routes/ai';

export default [
  ...publicRoutes,
  ...shellRoutes,
  ...crmRoutes,
  ...tasksRoutes,
  ...workflowsRoutes,
  ...botsRoutes,
  ...linkedinRoutes,
  ...integrationsRoutes,
  ...aiRoutes,
];
